<script setup lang="ts">
import { supplierClassificationClient } from '#shared/services/api/supplier-classification.client'
import QualitativeDimensions from '#taxonomy/components/QualitativeDimensions.vue'
import type { Dimension, DimensionBody, DimensionResource } from '#taxonomy/lib/resource'
import { ICONS } from '#utils/icons'

definePage({
  meta: { requiresAuth: true, title: 'Supplier Dimensions' },
})

const resource: DimensionResource = {
  queryKey: 'dimensions',
  icon: ICONS.supplierDimensions,
  title: 'Supplier Dimensions',
  description:
    'The dimensions used to categorize qualitative supplier information — notes, insights, and conversations collected across Deducta.',
  scopeNote: 'Every organization uses these dimensions to categorize supplier qualitative data.',
  dialogHint:
    'A dimension is a category used to classify supplier notes and insights — for example quality, delivery, or communication.',
  deleteNote: 'be available to categorize supplier qualitative data across',
  list: async (): Promise<Dimension[]> => {
    const { data } = await supplierClassificationClient.GET('/api/admin/dimensions')
    return data ?? []
  },
  create: async (body: DimensionBody) => {
    const r = await supplierClassificationClient.POST('/api/admin/dimensions', { body })
    return r.data!
  },
  update: async (id: string, body: DimensionBody) => {
    const r = await supplierClassificationClient.PUT('/api/admin/dimensions/{id}', {
      params: { path: { id } },
      body,
    })
    return r.data!
  },
  remove: async (id: string) => {
    await supplierClassificationClient.DELETE('/api/admin/dimensions/{id}', {
      params: { path: { id } },
    })
  },
}
</script>

<template>
  <QualitativeDimensions :resource="resource" />
</template>
